import type { LoadedSchema } from '@cli-types/core-engine/schema-reader.js'

export function isStoredSchemaJson(
  schemaJson: { name: string } | LoadedSchema['schema']
): schemaJson is LoadedSchema['schema'] {
  return 'fields' in schemaJson
}
